import { KMLLoader } from '@loaders.gl/kml';
import { load } from '@loaders.gl/core';
import { GeoJsonLayer } from '@deck.gl/layers';
import bbox from '@turf/bbox';
import { showMapConfirmToast } from "../utils/Toast/mapToast";

const handleFileOpen = async (file) => {
  try {
    if (!file) throw new Error('No file provided');

    const blob = new Blob([await file.text()], {
      type: 'application/vnd.google-earth.kml+xml',
    });

    const geojson = await load(blob, KMLLoader);

    return geojson;
  } catch (error) {
    console.error('Error processing file:', error);
  }
};

export const loadKML = async (file) => {
  try {
    const convertedGeojson = await handleFileOpen(file);
    return convertedGeojson;
  } catch (error) {
    console.error('Error loading KML:', error);
    throw error;
  }
};

export const setKMLLayer = (
  layerIndex,
  kml,
  setHoverInfo,
  setWfsLayers,
  setViewState
) => {
  setWfsLayers(prev => [
    ...prev,
    new GeoJsonLayer({
      id: `kml-${layerIndex}`,
      data: kml,
      source: "catalog",
      opacity: 1,
      pickable: true,
      stroked: true,
      filled: true,
      visible: true,
      pointType: 'circle',
      lineWidthMinPixels: 2,
      lineWidthScale: 2,
      getFillColor: [255, 0, 0, 100],
      getLineColor: [255, 0, 0, 200],
      getPointRadius: 2,
      getLineWidth: 2,
      onHover: info => setHoverInfo(info),
      onError: (error) => console.error('GeoJsonLayer error:', error),
    }),
  ]);

  if (kml && kml.features && kml.features.length > 0) {
    const [minX, minY, maxX, maxY] = bbox(kml);
    const centerLon = (minX + maxX) / 2;
    const centerLat = (minY + maxY) / 2;
    const lonRange = maxX - minX;
    const latRange = maxY - minY;
    const zoom = Math.log2(360 / Math.max(lonRange, latRange));

    showMapConfirmToast({
      title: "Pozicioniranje mape",
      message: "Da li želite da se prikaz mape pozicionira prema učitanom KML sloju?",
      confirmText: "Da",
      cancelText: "Ne",
      variant: "info",
      onConfirm: () => {
        setViewState(prev => ({
          ...prev,
          longitude: centerLon,
          latitude: centerLat,
          zoom,
          pitch: 0,
          bearing: 0,
          transitionDuration: 1000,
        }));
      },
    });
  }
};